import { DEMO_QUIZ } from './quiz-config.ts';

export type DemoTemplate = {
  id: string;
  templateVersion: string;
  name: string;
  note: string;
  visualCode: 'soft' | 'earth' | 'contrast';
  composition: 'rhythm' | 'focus';
  inlineComponentIds: string[];
  charmAnchorIndex: number;
};

export type DemoRecommendationConfig = {
  quizVersion: string;
  mappingVersion: string;
  catalogVersion: string;
  reviewStatus: 'demo';
  templates: DemoTemplate[];
  visualMappings: Record<'soft' | 'earth' | 'contrast', { rhythm: string; focus: string }>;
};

export const DEMO_RECOMMENDATION_CONFIG: DemoRecommendationConfig = {
  quizVersion: DEMO_QUIZ.quizVersion,
  mappingVersion: 'gbm-demo-visual-map-1',
  catalogVersion: 'gbm-synthetic-fixtures-1',
  reviewStatus: 'demo',
  templates: [
    {
      id: 'soft_rhythm', templateVersion: 'demo-template-1', name: 'Soft tonal rhythm', visualCode: 'soft', composition: 'rhythm',
      note: 'A repeating study in rose and sand demo colors.',
      inlineComponentIds: ['demo_rose_bead_8','demo_sand_bead_8','demo_rose_bead_8','demo_sand_bead_8','demo_rose_bead_8','demo_sand_bead_8'], charmAnchorIndex: 2,
    },
    {
      id: 'soft_focus', templateVersion: 'demo-template-1', name: 'Soft centered study', visualCode: 'soft', composition: 'focus',
      note: 'A quiet tonal sequence with one warm focal spacer.',
      inlineComponentIds: ['demo_rose_bead_8','demo_sand_bead_8','demo_gold_spacer','demo_sand_bead_8','demo_rose_bead_8'], charmAnchorIndex: 2,
    },
    {
      id: 'earth_rhythm', templateVersion: 'demo-template-1', name: 'Warm earth rhythm', visualCode: 'earth', composition: 'rhythm',
      note: 'A repeating study in sand and sage demo colors.',
      inlineComponentIds: ['demo_sand_bead_8','demo_sage_bead_8','demo_sand_bead_8','demo_sage_bead_8','demo_sand_bead_8','demo_sage_bead_8'], charmAnchorIndex: 2,
    },
    {
      id: 'earth_focus', templateVersion: 'demo-template-1', name: 'Warm earth focal study', visualCode: 'earth', composition: 'focus',
      note: 'Sand and sage demo colors gathered around one warm spacer.',
      inlineComponentIds: ['demo_sage_bead_8','demo_sand_bead_8','demo_gold_spacer','demo_sand_bead_8','demo_sage_bead_8'], charmAnchorIndex: 2,
    },
    {
      id: 'contrast_rhythm', templateVersion: 'demo-template-1', name: 'Gentle contrast rhythm', visualCode: 'contrast', composition: 'rhythm',
      note: 'Plum and sand demo colors in a steady repeat.',
      inlineComponentIds: ['demo_plum_bead_8','demo_sand_bead_8','demo_plum_bead_8','demo_sand_bead_8','demo_plum_bead_8','demo_sand_bead_8'], charmAnchorIndex: 2,
    },
    {
      id: 'contrast_focus', templateVersion: 'demo-template-1', name: 'Gentle contrast focal study', visualCode: 'contrast', composition: 'focus',
      note: 'A plum and rose demo sequence with a defined center.',
      inlineComponentIds: ['demo_plum_bead_8','demo_rose_bead_8','demo_gold_spacer','demo_rose_bead_8','demo_plum_bead_8'], charmAnchorIndex: 2,
    },
  ],
  visualMappings: {
    soft: { rhythm: 'soft_rhythm', focus: 'soft_focus' },
    earth: { rhythm: 'earth_rhythm', focus: 'earth_focus' },
    contrast: { rhythm: 'contrast_rhythm', focus: 'contrast_focus' },
  },
};
